import { getField, updateField } from 'vuex-map-fields'
import getCommissionDetailsReportFilter from './models/commissionDetailsReportFilters'
import { getCurrentUser, userHasRoles } from '@/lib/authentication'
import { ADMIN, MANAGER } from '@/lib/constants/securityRoles'

const commissionDetailsReportFilters = {
  namespaced: true,
  state: {
    ...getCommissionDetailsReportFilter()
  },
  getters: {
    getField,
    getSearchObject: (state) => {
      return state
    }
  },
  mutations: {
    updateField,
    clearFilters: (state) => {
      if (userHasRoles({ user: getCurrentUser(), allowedRoles: [ADMIN, MANAGER] })) {
        state.userId = null
      }
      state.year = new Date().getFullYear()
      state.month = new Date().getMonth() + 1
    }
  },
  actions: {
    clearFilters: ({ commit }) => {
      return commit('clearFilters')
    }
  }
}

export default commissionDetailsReportFilters
